











































import { Vue, Component, Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import AuthStore from "../../store/auth.store";

@Component
export default class RecognitionPageForm extends Vue {
  private userStore: AuthStore = getModule(AuthStore, this.$store);
  // feature flag determinations (reactive)
  private shouldShowVsValueForCustomerVariation: boolean = this.$launchDarkly.variation(
    "show-vs-value-for-customer",
    false
  );

  private get shouldShowVsValueForCustomer() {
    if (this.shouldShowVsValueForCustomerVariation) {
      return true;
    } else if (!this.userStore.getLaunchDarklyFlags) {
      return this.shouldShowVsValueForCustomerVariation;
    } else {
      return this.userStore.getLaunchDarklyFlags["show-vs-value-for-customer"]
        .current;
    }
  }

  @Prop() todayDate!: string;
  @Prop() storedStartDate!: string;
  @Prop() storedEndDate!: string;
  @Prop() storedSelectedCustomer!: string;
  private startDate = "";
  private endDate = "";
  private includeValidationServices = true;
  private rateOptions = [
    { value: true, label: "Include" },
    { value: false, label: "Exclude" }
  ];
  private get customers() {
    return this.userStore.getSites;
  }

  async created() {
    // assign values to class fields to avoid mutating props
    this.startDate = this.storedStartDate;
    this.endDate = this.storedEndDate;
  }

  handleDateFormSubmit(event: any) {
    this.$emit("selectionChanged", {
      startDate: this.startDate,
      endDate: this.endDate,
      site: event.target[0].value,
      includeValidationServices: this.includeValidationServices
    });
  }
}
